export const white = '#ffffff';
export const black = '#222222';
export const darkgrey = '#414141';
export const grey = '#a0a0a0';
export const inactive = '#dddddd';
export const lightgrey = '#c1c1c1';
export const defaultsearchcolor = '#bdbdbd';
export const divider = '#f6f6f6';
export const brand = '#ec691a';
export const brandHighlight = '#ffede0';
export const background = '#fcfcfc';
export const blueish = '#d9dde4';
export const acceptgreen = '#009900';
export const statusbargreen = '#4caf50';
export const warningred = '#d0021b';
export const mark = '#ffef34';
export const positionbargreen = '#0cd90c';
export const positionbarred = '#fd6464';
export const yellow = '#fe9800';
export const normalgreen = '#188518';
// colors below should be reviewed by the design team asap, they are not in the design system or in the baseball stadium system
export const border = '#7e7e7e';
export const dot = '#979797';
export const borderDialog = '#dfdfdf';
export const vsColor = '#4e4e4e';
export const teamNameDialog = '#333';
export const noticeWarning = '#ee1b34';
export const reviewSubtitle = '#b7b7b7';
export const reviewBlue = '#2969c1';
export const reviewLine = '#d8d8d8';
export const reviewErrorBgOdd = '#e8d8e4';
export const reviewErrorBgEven = '#e2d3df';
export const reviewSuccessBgEven = '#d1e7d1';
export const reviewSuccessBgOdd = '#dff5df';
export const gridError = '#ff2d55';
export const tableOdd = '#F5F5F5';
export const filtersBackground = 'rgba(212, 212, 212, 0.5)';
export const filtersGrey = 'rgba(0, 0, 0, 0.54)';
export const autosaveInfoColor = '#7b7b7b';
export const saveButtonBackgroundColor = '#f5f5f5';
export const separatorColor = '#e0e0e0';
export const rotateButtonBackgroundColor = '#f5f5f5';
export const secondValueColor = '#7b7b7b';
export const descriptionGrey = '#7b7b7b7';
export const newMark = '#fbe1d1';
export const settingsButtonBackgroundColor = '#f5f5f5';
